export default __webpack_public_path__ + "static/media/blog-driveway-cost-001.28c50851.jpg";